module.exports = __webpack_public_path__ + "static/img/weather11.55a1b4fa.png";